import { urls } from '../../../../config';
import { apiRequest, callbackApiRequest } from '../../apiRequest';
import { selfCancellingAction } from '../../selfCancellingAction';
import { selectedExtrasTotalSelector } from '../form/selectors';
import {
  COMPLETE_BOOKING,
  CREATE_BOOKING,
  CUSTOM_BOOKING_PAYMENT,
  CUSTOM_BOOKING_PAYMENT_ERR,
  GET_DEPOSIT,
  LOAD_BOOKING,
  RESET_BOOKING,
  RESET_STEPS_COMPLETED,
  SET_DISCOUNT_CODE,
  SET_DISCOUNT_VALUE,
  SET_PREVIOUS_BOOKING_ID,
  STEP_COMPLETED,
  STEP_NOT_COMPLETED,
  SET_BOOKING_TIMED_OUT,
} from './action-types';

export const [createBooking, cancelCreateBooking] = selfCancellingAction(
  (
    dispatch,
    { channelId, parkId, unitId, unitTypeId, unitPrice, promo, arrivalDate, duration, party = {}, searchId },
  ) => {
    const parkBookingUrl = window.location.pathname + window.location.search;
    return dispatch((d, getState) => {
      const state = getState();
      const previousUnitId = state.booking.booking.unitId;
      const sameUnitAsPreviousJourney = previousUnitId === unitId;
      if (sameUnitAsPreviousJourney) {
        d({ type: RESET_STEPS_COMPLETED });
        return;
      }
      d({
        type: CREATE_BOOKING,
        payload: {
          type: 'new',
          channelId,
          unitId,
          unitTypeId,
          unitPrice,
          promo,
          parkId,
          arrivalDate: arrivalDate?.toISOString(),
          duration,
          party,
          discountApplied: false,
          discountCode: '',
          discountValue: 0,
          parkBookingUrl,
        },
      });
      return apiRequest(d, CREATE_BOOKING, urls.booking, { unitId, searchId, promo, ...party });
    });
  },
);

export const [getDeposit, cancelGetDeposit] = selfCancellingAction((dispatch, bookingId) => {
  return apiRequest(dispatch, GET_DEPOSIT, urls.bookingGetDeposit, { bookId: bookingId });
});

export const storeDiscountCode = (dispatch, code) => {
  return dispatch({
    type: SET_DISCOUNT_CODE,
    payload: code.toString(),
  });
};

export const storeDiscountValue = (dispatch, value) => {
  dispatch((d, getState) => {
    const state = getState();
    const extrasPrice = selectedExtrasTotalSelector(state);
    return d({
      type: SET_DISCOUNT_VALUE,
      payload: { data: parseFloat(value), extrasPrice },
    });
  });
};

export const completeBooking = (dispatch) => {
  return dispatch({ type: COMPLETE_BOOKING });
};

export const loadBooking = (
  dispatch,
  bookingId,
  channelId,
  parkId,
  unitId,
  unitTypeId,
  totalCost,
  amountPaid,
  arrivalDate,
  duration,
) => {
  dispatch({
    type: LOAD_BOOKING,
    payload: {
      type: 'existing',
      bookingId,
      channelId,
      unitId,
      unitTypeId,
      totalCost,
      amountPaid,
      parkId,
      arrivalDate,
      duration,
    },
  });
};

export const stepCompleted = (dispatch, step) => {
  dispatch({ type: STEP_COMPLETED, payload: step });
};

export const stepNotCompleted = (dispatch, step) => {
  dispatch({ type: STEP_NOT_COMPLETED, payload: step });
};

export const [setDiscount, cancelSetDiscount] = selfCancellingAction((dispatch, bookingId, dCode) => {
  const obj = {
    bookId: bookingId,
    discountCode: dCode,
  };
  return callbackApiRequest(dispatch, SET_DISCOUNT_CODE, urls.bookingSetDiscount, obj, undefined, 'post');
});

export const customBookingValue = (dispatch, value) => {
  dispatch({ type: CUSTOM_BOOKING_PAYMENT, payload: value });
};

export const customBookingValErr = (dispatch, value) => {
  dispatch({ type: CUSTOM_BOOKING_PAYMENT_ERR, payload: value });
};

export const setPreviousBookingId = (dispatch, value) => {
  dispatch({ type: SET_PREVIOUS_BOOKING_ID, payload: value });
};

export const clearCurrentBooking = (dispatch) => {
  dispatch({ type: RESET_BOOKING });
};

export const setBookingTimedOut = (dispatch) => {
  dispatch({ type: SET_BOOKING_TIMED_OUT });
};